import { render, staticRenderFns } from "./StepWelcome.vue?vue&type=template&id=5827eb12&scoped=true&"
import script from "./StepWelcome.vue?vue&type=script&lang=js&"
export * from "./StepWelcome.vue?vue&type=script&lang=js&"
import style0 from "./StepWelcome.vue?vue&type=style&index=0&id=5827eb12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5827eb12",
  null
  
)

export default component.exports